module.exports = __webpack_public_path__ + "media/bootstrap-icons/telephone-inbound-20bd8c97.svg";